import React from 'react'
import { Grid, Typography } from '@mui/material'

function GridProps({ name = '', value = '', xsStart = 6, xsEnd = 6, typographyProps1={} }) {
  return <React.Fragment>
    <Grid item xs={xsStart}><Typography {...typographyProps1}>{name}</Typography></Grid>
    <Grid item xs={xsEnd}>{(typeof value === 'object') ? value : <Typography>{value}</Typography>}</Grid>
  </React.Fragment>
}
export default GridProps